export default{
    errorMsg:null,
    successMsg:null,
    manageProgramList:null,
    programColumns:null,
    programMeta:null,
    editProgram:null,
    programMsg:null,
}